import { Component, Input, OnInit, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { CustomerService } from '../../../../services/customer.service';
import { PartnerGroupService } from '../../../../services/partner-group.service';
import { PreAuditDetailService } from '../../../../services/pre-audit-detail.service';
import { forkJoin } from 'rxjs';
import { SessionStorageService } from '../../../../services/session-storage.service';

/*
 * Adds external access note to the save and validation for the customer account group.
 */
@Component({
  selector: 'app-components-managecustomer-cms',
  templateUrl: './CmsSelection.Component.html'
})
export class CmsSelectionComponent implements OnInit {
  @Input() customerId: number;
  @Input() partnerId: number;

  @Output() cmsChange: EventEmitter<Boo.Objects.ContentManagementSystem> = new EventEmitter<Boo.Objects.ContentManagementSystem>();

  isLoading = false;
  contentManagementSystems: Boo.Objects.ContentManagementSystem[];
  contentManagementSystem: Boo.Objects.ContentManagementSystem;

  constructor(
    private customerService: CustomerService,
    private partnerGroupService: PartnerGroupService,
    private preAuditDetailService: PreAuditDetailService,
    private sessionStorageService: SessionStorageService) { }

  ngOnInit(): void {
    forkJoin([
      this.preAuditDetailService.getByCustomerId(this.customerId),
      this.sessionStorageService.getStaticData(),
      this.partnerGroupService.get(this.partnerId)
    ])
    .subscribe(([preAudit, staticData, partnerGroups]) => {
      this.contentManagementSystems = staticData.ContentManagementSystems;
      this.contentManagementSystem = preAudit ? staticData.ContentManagementSystems.find((i: { ContentManagementSystemId: any; }) => i.ContentManagementSystemId === preAudit.ContentManagementSystemId) : null;
      this.contentManagementSystemChanged();
    });
  }

  contentManagementSystemChanged(): void {
    this.cmsChange.emit(this.contentManagementSystem);
  }

  recheckCustomerCMS(): void {
    this.isLoading = true;
    this.customerService.getCustomerCmsId(this.customerId).subscribe(
      x => {
        this.contentManagementSystem = this.contentManagementSystems.find(i => i.ContentManagementSystemId === x);
        x === 0 ? toastr.warning(`No CMS found for customer ${this.customerId}`) : toastr.success('Successfully Updated CMS');
      },
      err => {
        toastr.error(err);
        this.isLoading = false;
      },
      () => {
        this.contentManagementSystemChanged();
        this.isLoading = false;
      });
  }
}
